module.exports = __webpack_public_path__ + "static/media/screen-printed-band.15c6f50e.jpg";